import dynamic from 'next/dynamic'
import ListingCardGrid from './ListingCardGrid'
import NoResults from './NoResults'

const SearchResultsMap = dynamic(() => import('./SearchResultsMap'))

const SearchResults = ({
  items,
  searchView,
  mapResults,
  queryParams,
  totalItems,
  onClearSearch,
  minPage = 1,
  onPropertyClick,
}) => {
  return (
    <div>
      {items?.length > 0 ? (
        items && searchView === 'map' ? (
          <SearchResultsMap
            properties={mapResults.results}
            queryParams={queryParams}
            listingCount={mapResults.count}
            view={searchView}
            totalItems={totalItems}
          />
        ) : items ? (
          <ListingCardGrid
            items={items}
            searchView={searchView}
            queryParams={queryParams}
            minPage={minPage}
            onPropertyClick={onPropertyClick}
          />
        ) : null
      ) : (
        <NoResults queryParams={queryParams} onClearSearch={onClearSearch} />
      )}
    </div>
  )
}

SearchResults.defaultProps = {
  items: [],
  metaData: {},
}

export default SearchResults
